import { jsx as _jsx } from "react/jsx-runtime";
import { Avatar } from "@air/primitive-avatar";
import { tailwindMerge } from "@air/tailwind-variants";
import { formatFullName, formatInitials } from "@air/utilities";
import { memo, useMemo } from "react";
import { getAvatarImageSrc } from "~/utils/getAvatarImageSrc";
export const BOUNDING_BOX_AVATAR_WIDTH = 24;
// 10 is: 4px padding  + 1px border on left and right
export const BOUNDING_BOX_AVATAR_SIZE = BOUNDING_BOX_AVATAR_WIDTH + 10;
export const BoundingBoxAvatar = /*#__PURE__*/ memo((param)=>{
    let { account, direction, className } = param;
    const fullName = account ? formatFullName(account.firstName, account.lastName) : "";
    const initials = account ? formatInitials(account.firstName, account.lastName) : "";
    const borderRadiusStyle = useMemo(()=>{
        const borderRadius = {
            borderBottomLeftRadius: 30,
            borderTopRightRadius: 30,
            borderTopLeftRadius: 30,
            borderBottomRightRadius: 30
        };
        switch(direction){
            case "top-left":
                borderRadius.borderTopLeftRadius = 2;
                break;
            case "top-right":
                borderRadius.borderTopRightRadius = 2;
                break;
            case "bottom-left":
                borderRadius.borderBottomLeftRadius = 2;
                break;
            case "bottom-right":
                borderRadius.borderBottomRightRadius = 2;
                break;
        }
        return borderRadius;
    }, [
        direction
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: tailwindMerge("light:border-grey-1 light:bg-grey-3 pointer-events-none border p-1 shadow-popover dark:border-grey-12 dark:bg-grey-12", className),
        style: {
            width: BOUNDING_BOX_AVATAR_SIZE,
            height: BOUNDING_BOX_AVATAR_SIZE,
            ...borderRadiusStyle
        },
        children: /*#__PURE__*/ _jsx(Avatar, {
            alt: fullName,
            size: BOUNDING_BOX_AVATAR_WIDTH,
            src: getAvatarImageSrc(account === null || account === void 0 ? void 0 : account.avatar, BOUNDING_BOX_AVATAR_WIDTH),
            text: initials,
            colorSeed: account === null || account === void 0 ? void 0 : account.id
        })
    });
});
BoundingBoxAvatar.displayName = "BoundingBoxAvatar";
